import Vue from 'vue'
import { quillEditor } from 'vue-quill-editor'

import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme

import _Quill from 'quill'
const Quill = window.Quill || _Quill
// 将样式默认使用class的替换为内联样式
let ColorStyle = Quill.import('attributors/style/color')
let SizeStyle = Quill.import('attributors/style/size')
let FontStyle = Quill.import('attributors/style/font')
let AlignStyle = Quill.import('attributors/style/align')
// 自定义字体大小尺寸，需对应修改html中下拉框，以及相关样式
SizeStyle.whitelist = ['12px', '14px', '16px', '18px', '20px', '22px', '24px', '26px', '28px', '30px', '32px', '36px', '40px', 'large', 'huge', 'small', 'Large', 'Huge']
// 自定义字体类型，需对应修改html中下拉框，以及相关样式
FontStyle.whitelist = [
  'lato',
  'PingFangHK-Semibold',
  'PingFangHK-Regular',
  'Source Sans Pro',
  '-apple-system',
  'BlinkMacSystemFont',
  'Segoe UI',
  'Roboto',
  'Helvetica Neue',
  'Arial',
  'sans-serif']
Quill.register(SizeStyle, true)
Quill.register(FontStyle, true)
Quill.register(AlignStyle, true)
Quill.register(ColorStyle, true)

const BlockEmbed = Quill.imports['blots/embed']

class ImageBlot extends BlockEmbed {
  static create(value) {
    let node = super.create()
    node.setAttribute('src', value.src)
    node.setAttribute('alt', value.alt)
    node.setAttribute('style', value.style)
    return node
  }
  static value(node) {
    return {
      src: node.getAttribute('src'),
      alt: node.getAttribute('alt'),
      style: node.getAttribute('style'),
    }
  }
}

ImageBlot.blotName = 'image'
ImageBlot.tagName = 'img'
Quill.register(ImageBlot)

// 自定義行高
const Parchment = Quill.import('parchment')
class lineHeightAttributor extends Parchment.Attributor.Style {}
let lineHeight = new lineHeightAttributor('lineHeight',
  'line-height', {
    scope: Parchment.Scope.INLINE,
    whitelist: ['1', '1.1','1.2','1.3','1.4','1.5','1.6','1.7','1.8','1.9','2','2.1','2.2','2.3','2.4','2.5','2.6','2.7','2.8','2.9','3']
  }
)
Quill.register(
  { 'formats/lineHeight': lineHeight }, true
)

Vue.component('quill-editor', quillEditor)